<template>
	<div>
		<b-container v-if="loginPhase == 'select'" id="authentication-selector">
			<b-row align-h="center" class="text-center mb-4">
				<b-col col-sm="5">
					<h1>Üdvözöljük!</h1>
				</b-col>
			</b-row>
			<b-row align-h="center" class="text-center mb-4">
				<b-col col-sm="5">
					<b-button id="type-type-login-button" size="lg" variant="info" @click="loginPhase = 'typeLogin'">Belépés az ügyelő számának és jelszavának használatával</b-button>
				</b-col>
			</b-row>
			<b-row align-h="center" class="text-center mb-4">
				<b-col col-sm="5">
					<b-button id="qr-type-login-button" size="lg" variant="info" @click="loginPhase = 'qrLogin'" :disabled="cameraDisabled">Az ügyelő QR kódjának a beolvasása</b-button>
				</b-col>
			</b-row>
			<b-row align-h="center" class="text-center mb-4">
				<b-col col-sm="5">
					<p>Amennyiben problémája adódna a belépéssel, kérjük, jelezze szolgálatvezetőjének telefonon!</p>
				</b-col>
			</b-row>
		</b-container>
			<b-container v-if="loginPhase == 'qrLogin'" id="qr-authentication-box">
			<b-form-row>
				<b-col v-if="showQrAuthentication" id="qr-authentication" col-sm="5">
					<b-alert variant="danger" :show="invalidLogin" dismissible @dismissed="cleanErrorState">{{ invalidLoginMessage }}</b-alert>
					<h4 id="qr-authenticator-title">QR kód beolvasása</h4>
					<vue-qr-reader id="qr-authenticator" v-on:code-scanned="codeArrived" @error-captured="cameraError" />
					<b-button size="sm" variant="outline-info" @click="loginPhase = 'select'">Vissza</b-button>
				</b-col>
			</b-form-row>
			</b-container>
			<b-container v-if="loginPhase == 'typeLogin'" id="type-authentication-box">
			<b-form-row>
				<b-col align-self="center" id="typing-authentication">
					<b-alert variant="danger" :show="invalidLogin" dismissible @dismissed="cleanErrorState">{{ invalidLoginMessage }}</b-alert>
					<b-form @submit.prevent="onSubmit" id="login-form">
						<h1>Bejelentkezés</h1>
						<b-form-group
    						label="Szolgálati hely:"
    						label-for="password-field"
						>
							<b-form-input id="location-field" type="text" v-model="location"/>
						</b-form-group>
				 		<b-form-group
    						label="Felhasználónév:"
    						label-for="user-field"
						>
							<b-form-input id="user-field" type="text" v-model="username"/>
						</b-form-group>
						<b-form-group
    						label="Jelszó:"
    						label-for="password-field"
						>
							<b-form-input id="password-field" type="password" v-model="password"/>
						</b-form-group>
						<b-button variant="outline-info" @click="loginPhase = 'select'" class="mr-3">Vissza</b-button>
						<b-button variant="info" id="login-submit" type="submit">BEJELENTKEZÉS</b-button>
					</b-form>
				</b-col>
			</b-form-row>
		</b-container>
	</div>
</template>

<script>
import FormService from '@/services/FormService'
import VueQrReader from 'vue-qr-reader/dist/lib/vue-qr-reader.umd.js'
import { messages } from '@/texts/messages'
import debounce from 'lodash/debounce'

export default {
	name: 'login',
	components: {
		VueQrReader
	},
	data() {
		return {
			username: '',
			password: '',
			location: '',
			invalidLogin: false,
			invalidLoginMessage: '',
			showQrAuthentication: true,
			loginPhase: 'select',
			cameraDisabled: false
		}
	},
	async mounted() {
		try {
		 	await navigator.mediaDevices.getUserMedia({video: true})
		} catch(e) {
			this.cameraDisabled = true
		}
	},
	methods: {
		onSubmit: debounce(async function() {
			this.invalidLogin = false;
			const service = new FormService()

			const mergedUsername = this.location ? this.location + '_' + this.username : this.username
			try {
				const token = await service.login(mergedUsername, this.password)

				this.$session.set('token', token)
				this.$store.commit('setUsername', this.username)
				this.$router.push({name: 'Home'})
			}
			catch (e) {
				this.invalidLoginMessage = e.message
				this.invalidLogin = true;
			}
		}, process.env.VUE_APP_DEBOUNCE_RATE, { leading: true}),
		codeArrived(code) {
			const userAndPassword = code.split(':::')

			if (userAndPassword.length != 2)
			{
				this.invalidLogin = true;
				this.invalidLoginMessage = messages.invalid_qr_code
				return
			}

			this.username = userAndPassword[0]
			this.password = userAndPassword[1]
			this.onSubmit()
		},
		cameraError(error) {
			if (error.name == 'NotFoundError')
				this.showQrAuthentication = false
		},
		cleanErrorState() {
			this.invalidLogin = false
			this.invalidLoginMessage = ''
		}
	}
}
</script>

<style scoped>
#typing-authentication {
	margin-bottom:1em;
}
</style>